import { useQuery } from "@tanstack/react-query";
import { api } from "./api.ts";

// The caller's org memberships WITH the suspension flag — what the header
// switcher and the suspended-org screen key off. Better-Auth's
// organization.list() can't see organization.blockedAt, so this wraps our
// /v1/me/orgs instead.
export function useMyOrgs() {
  const q = useQuery({
    queryKey: ["me", "orgs"],
    queryFn: api.myOrgs,
    staleTime: 60_000,
    retry: false,
  });
  return { orgs: q.data?.orgs ?? null, isPending: q.isPending };
}
